import { Icon, Pill } from "@/components/ui";
import type { ReactNode } from "react";

// 확인 컨펌 다이얼로그 — 위험한 동작(삭제 등) 전 1회 확인. 오버레이 패턴은 ProductWeightCalcModal 과 동일.
export const ConfirmDialog = ({
  title,
  message,
  confirmLabel = "확인",
  cancelLabel = "취소",
  busy = false,
  onConfirm,
  onCancel,
}: {
  title: string;
  message: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) => (
  <div
    onClick={onCancel}
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.6)",
      zIndex: 70,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 20,
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        width: 420,
        maxWidth: "100%",
        background: "var(--bg-surface)",
        borderRadius: 14,
        boxShadow: "rgba(0,0,0,0.5) 0px 8px 24px",
        padding: 24,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
        <Icon name="alert" size={18} color="var(--text-negative)" />
        <div style={{ fontFamily: "var(--font-title)", fontWeight: 800, fontSize: 17 }}>{title}</div>
      </div>
      <div style={{ fontSize: 13.5, color: "var(--text-near)", lineHeight: 1.6 }}>{message}</div>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 22 }}>
        <Pill variant="outlined" size="sm" onClick={onCancel} disabled={busy}>
          {cancelLabel}
        </Pill>
        <Pill
          variant="primary"
          size="sm"
          onClick={onConfirm}
          disabled={busy}
          style={{ background: "var(--text-negative)" }}
        >
          {busy ? "처리 중…" : confirmLabel}
        </Pill>
      </div>
    </div>
  </div>
);
